import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useParams } from "react-router"
import { DraftStatus } from "authoring/lib/enum/draft-status.mjs"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { isEnabled } from "lib/@components/feature"
import { AUTHORING_GENERATE_SCHEDULE_COMMENTARY_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"
import { FEATURE_FLAG_SCHEDULE_COMMENTARY } from "authoring/lib/enum/authoring-feature-flags.mjs"
import { navigateScheduleCommentary } from "../../utilities/project-navigation"

export function ReviewCommentary() {
    const { projectId } = useParams()
    const { targetId: scheduleId, status } = useBoundContext()

    if (!isEnabled(FEATURE_FLAG_SCHEDULE_COMMENTARY)) return null
    if (status !== DraftStatus.APPROVED) return null

    return (
        <Secure demand={AUTHORING_GENERATE_SCHEDULE_COMMENTARY_DEMAND} fallback={<Frag />}>
            <ContextMenuItem
                icon="mdi:comment-text-outline"
                label="View Commentary"
                onClick={() => navigateScheduleCommentary({ projectId, scheduleId })}
                data-cy="review-commentary-menu-item"
            />
        </Secure>
    )
}
